import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home/home";
import Menu from "./pages/menu/menu";
import Drinks from "./pages/drinks/drinks";
import Food from "./pages/food/food";
import NotCool from "./pages/dev/not_cool";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/tragos" element={<Drinks />} />
        <Route path="/comidas" element={<Food />} />
        <Route path="*" element={<NotCool />} />
      </Routes>
    </Router>
  );
}

export default App;

/**@copyright Eze © 2025 */